unable to read source [project]/node_modules/@yudiel/react-qr-scanner/src/misc/defaultStyles.ts